<template>
    <el-drawer
        title="新增班级"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        v-loading="submiting"
        element-loading-text="数据提交，并同步生成排课中...请等待"
        :before-close="close">
        <div class="panel fx-g1">
            <el-tabs v-model="activeTab" >
                <el-tab-pane label="添加班级" name="addNew">
                    <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                        <el-form-item label="班级名称"  v-check="{'必填': !form.name}">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="班级类型"  v-check="{'必选': !form.useType}">
                            <el-select v-model="form.useType" clearable placeholder="班级类型" @change="changeLessonSystems">
                                <el-option label="普通班级" :value="1"></el-option>
                                <el-option label="收费班级" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="授权课程体系">
                            <el-checkbox-group v-model="form.lessonSystemIds" class="fx-col fx-m_start fx-c_start">
                                <el-checkbox v-for="item in lessonSystems" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="选择教师">
                            <el-select v-model="form.teacherId" placeholder="请选择教师">
                                <el-option v-for="item in staffs" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>

                </el-tab-pane>
                <el-tab-pane label="批量添加" name="addFromLib" v-loading="uploading" element-loading-text="文件上传中，请稍后...">
                    <div class="fx-g1 fx-col fx-center">
                        <span style="width: 80%; margin: 30px 0;font-size: 16px" class="text_normal">导入班级：快速生成班级，教师，以及学生之间的关系，请严格按照模板样式上传，否则会导致数据导入失败！</span>
                        <div class="fx fx-center">
                            <div class="excel_opt fx-col fx-center" @click="downloadModal">
                                <i class="iconfont icon-yunshangchuan"></i>
                                <span>下载模板</span>
                            </div>
                            <i class="el-icon-arrow-right text_primary"></i>
                            <div class="excel_opt fx-col fx-center" @click="$refs.file.click()">
                                <i class="iconfont icon-yunxiazai"></i>
                                <span>上传Excel</span>
                                <input type="file" ref="file" @change="subExcel($event)" accept="application/vnd.ms-excel"  class="hide">
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>


        </div>
        <span  class="fx fx-center">
            <el-button v-if="activeTab=='addNew'" type="primary" @click="subOne()">保 存</el-button>
            <el-button v-else type="primary" @click="subExcel()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .excel_opt {
        width: 130px;
        height: 130px;
        border-radius: 10px;
        border: 1px solid var(--primary);
    }
    .excel_opt .iconfont{
        color: var(--primary);
        font-size: 50px;
    }
    i.el-icon-arrow-right {
        font-size: 50px;
        font-weight: bold;
        margin: 0 20px;
    }
</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                submiting: false, //是否正在提交中


                activeTab: "addNew",
                form: {lessonSystemIds: [],useType:1},
                lessonSystems: [],
                staffs: [],

                uploading: false,

                needRefreshParent: false,
            }

        },


        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            subOne() {
                // if(this.form.lessonSystemIds.length==0){
                //         this.$showError("请选择体系");
                //         return
                // }
                this.submiting = true;
                this.$checkForm(this.$refs.form).then(success => {
                    if (success) {
                        //校验通过，干什么....
                        this.$ajaxPost("/class/save", {
                            clazz: {...this.form, lessonSystemIds: this.form.lessonSystemIds.join(",")}
                        }, (data) => {
                            this.submiting = false;
                            this.$emit("submit", data.result);
                            this.needRefreshParent = true;
                            this.$showSuccess("保存成功");
                            this.show = false;
                        }, (data) => {
                            this.submiting = false;
                            this.$showError(data.msg, 1200);
                        })
                        return false;
                    } else {
                        this.$showError("请输入内容再保存");
                    }
                })

            },
            subExcel(e) {
                if (e.target.value) {
                    this.uploading = true;
                    let file = e.target.files[0];
                    this.$upload("/class/addFromExcel", {file: file}, data => {
                        this.$showSuccess("上传成功");
                        this.uploading = false;
                        this.needRefreshParent = true;
                    }, data => {
                        this.uploading = false;
                        this.$showError(data.msg);
                    })
                }
            },
            loadLessonSystems() {
                this.$ajaxPost("/lessonSystem/listLessonSystem", {
                    form: {enable: true,useType:this.form.useType}
                }, (data) => {
                    this.lessonSystems = data.result;
                })
            },
            changeLessonSystems() {
                this.form.lessonSystemIds=[];
                this.loadLessonSystems();
            },
            // loadLessonSystems() {
            //     this.$ajaxPost("/lessonSystem/list", {
            //         form: {enable: true}
            //     }, (data) => {
            //         this.lessonSystems = data.result;
            //     })
            // },
            loadTeachers() {
                this.$ajaxPost("/user/list", {
                    form: {
                        enable: true
                    },
                    isStaff: true
                }, data => {
                    this.staffs = data.result;
                })
            },
            downloadModal() {
                window.open("/class/downloadExcelModal");
            }

        },
        mounted() {
            this.show = true;

        },
        created() {
            this.loadLessonSystems();
            this.loadTeachers();

        }


    }
</script>
